<svg
	aria-hidden="true"
	xmlns="http://www.w3.org/2000/svg"
	fill="none"
	viewBox="0 0 23 20"
>
	<path
		fill="currentColor"
		d="M20.1312 2.55835H3.86928C3.08686 2.55835 2.45898 3.21102 2.45898 4.01315V15.9455C2.45898 16.7476 3.08686 17.4003 3.86928 17.4003H20.1312C20.9088 17.4003 21.5415 16.7476 21.5415 15.9455V4.01315C21.5415 3.21102 20.9088 2.55835 20.1312 2.55835ZM19.8945 10.8936H17.9143C16.0887 10.8936 14.4224 11.7754 13.1377 13.1156C13.1328 13.1206 13.128 13.1256 13.1232 13.1306C12.8334 13.4295 12.4373 13.6138 11.9978 13.6138C11.5583 13.6138 11.1623 13.4295 10.8725 13.1306L10.858 13.1156C9.57327 11.7754 7.90699 10.8936 6.08133 10.8936H4.10111V9.54339C4.10111 9.16972 4.40056 8.85584 4.76763 8.85584H19.228C19.5951 8.85584 19.8945 9.16972 19.8945 9.54339V10.8936ZM19.8994 6.11564H4.10111V4.76546C4.10111 4.38681 4.40056 4.07792 4.77246 4.07792H19.2329C19.5999 4.07792 19.8994 4.38681 19.8994 4.76546V6.11564Z"
	/>
</svg>

<style>
	svg {
		height: 1.25rem;
		width: 1.25rem;
		color: inherit
}
</style>
